<template>
  <v-skeleton-loader type="article@2"></v-skeleton-loader>
</template>

<script>
export default {};
</script>

<style></style>
